import { Panel } from "../layout/Panel.tsx";
import { MetricCard } from "../viz/MetricCard.tsx";
import { metrics } from "../../stores/metrics.ts";

const NR_APM = "https://one.newrelic.com/redirect/entity/MTg3NzkxMXxBUE18QVBQTElDQVRJT058MTE0NTE0NzM2NA";

export function PerformancePanel() {
  const get = (m: string) => metrics.latest[`newrelic-apm:${m}`]?.value;
  return (
    <Panel title="Performance · New Relic APM" href={NR_APM} span="col-span-4 row-span-1">
      <div class="grid grid-cols-2 gap-3">
        <MetricCard label="Error Rate" value={get("error_rate")} unit="%" digits={2} />
        <MetricCard label="Resp Time" value={get("response_time_ms")} unit="ms" digits={0} />
        <MetricCard label="Throughput" value={get("throughput_rpm")} unit="/m" digits={0} />
        <MetricCard label="Apdex" value={get("apdex")} digits={2} />
      </div>
    </Panel>
  );
}
